export default __webpack_public_path__ + "static/media/PRESSIONE SANGUIGNA_ICONA.e125c5ee.svg";